import {
  OpenEmojiPickerAction,
  openEmojiPickerAction,
} from 'actions/emoji/openEmojiPickerAction'
import { AsyncThunkAction } from 'actions/types'
import { EmojiTextHandler } from 'components/page/Chat/Messenger/EmojiPicker/EmojiPicker.types'

export const toggleEmojiPickerAction =
  (): AsyncThunkAction => (dispatch, getState) => {
    const {
      emoji: { pickerOpened },
    } = getState()
    return dispatch(openEmojiPickerAction(!pickerOpened))
  }

export const SET_EDITOR_CURSOR_POSITION = 'SET_EDITOR_CURSOR_POSITION'

interface SetCursorPositionAction {
  type: typeof SET_EDITOR_CURSOR_POSITION
  start: number
  end: number
}

export const setCursorPositionAction = (start: number, end: number) => ({
  type: SET_EDITOR_CURSOR_POSITION,
  start,
  end,
})

export const updateTextWithEmojiAction =
  (emoji: string, textHandler: EmojiTextHandler): AsyncThunkAction =>
  (dispatch, getState) => {
    const {
      emoji: { cursorPositionStart, cursorPositionEnd },
      chatMessengerReducer: { contentInput } = {},
    } = getState()

    const text = contentInput || ''

    const mergedContentWithEmoji =
      text.slice(0, cursorPositionStart) + emoji + text.slice(cursorPositionEnd)

    textHandler(mergedContentWithEmoji)
    dispatch(
      setCursorPositionAction(
        cursorPositionStart + emoji.length,
        cursorPositionEnd + emoji.length
      )
    )
  }

export type EmojiActionTypes = OpenEmojiPickerAction | SetCursorPositionAction
